module.exports = __webpack_public_path__ + "static/media/marks-card-bg.f19a8168.png";